import { useNavigate } from "react-router-dom";
import useCartStore from "../store/cartStore";

const FloatingCart = () => {
  const navigate = useNavigate();
  const { getTotalItems } = useCartStore();

  const totalItems = getTotalItems();

  const goToCart = () => {
    navigate("/cart");
  };

  return (
    <div className="fixed right-5 md:right-6 bottom-5 md:bottom-6 z-100 flex flex-col gap-2">
      {/* Bouton Panier */}
      {
        totalItems > 0 &&
        <button
          onClick={goToCart}
          className="relative h-12 w-12 rounded-full bg-[#FF4081] flex items-center justify-center hover:bg-[#FF4081]/90 shadow-lg transition-all duration-300 group"
        >
          {/* Badge du nombre d'articles */}
          {totalItems > 0 && (
            <span className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center font-nunito text-[14px] font-semibold">
              {totalItems}
            </span>
          )}

          {/* Icône panier */}
          <div className="flex items-center justify-center">
            <svg
              className="h-5 w-5 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
              />
            </svg>
          </div>

          {/* Tooltip */}
          <div className="absolute right-14 top-1/2 transform -translate-y-1/2 bg-gray-800 text-white font-nunito text-[14px] px-2 py-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
            Voir le panier ({totalItems})
          </div>
        </button>
      }
    </div>
  );
};

export default FloatingCart;